import { render, staticRenderFns } from "./Region.container.vue?vue&type=template&id=05a0f300&"
import script from "./Region.container.vue?vue&type=script&lang=ts&"
export * from "./Region.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports